/* Built In Imports */

/* External Imports */
import { Box, Container, Flex, Image } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import config from '@config';
import SectionTitle from '@app-ila/components/Text/SectionTitle';

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const HMM7Step = ({ sectionContent }) => {
  const isLessThen = useMediaQuery({ maxWidth: 560 });
  return (
    <Box
      fontFamily="var(--FedraSansStd-book)"
      mx="auto"
      w="100%"
      maxW={{ base: '100%', md: '100%', lg: '100%', xl: 1330, '2xl': '1330px' }}
      pt={{ base: '30px', md: '40px', xl: '40px' }}
      pb={{ base: '60px', md: '40px', xl: '0px' }}
    >
      <Box
        bg={`url(${config.imgPath}/d/46272/1747821084-7step_bg.png)`}
        position="relative"
        bgRepeat="no-repeat"
        bgSize={{ md: '100% 100%', base: '100% 910px' }}
        display={'flex'}
        flexDirection={{ base: 'column', sm: 'row' }}
        flexWrap={{ base: 'wrap', xl: 'nowrap' }}
        pb={{ base:'30px', lg:'0px'}}
      >
        <Box
          padding={{
            '2xl': '50px 0px 50px 135px',
            xl: '50px 0px 50px 80px',
            md: '50px 0px 50px 45px',
            base: '25px 0px 22px 35px',
          }}
          maxW={'440px'}
        >
          <Flex
            flexDirection="column"
            position="relative"
            m="0 auto 20px auto"
            pt="60px"
            pl="16px"
            maxWidth="1170px"
            className="sectiontitle"
          >
            <SectionTitle lineHeight={'100%'} titleObj={sectionContent[0]} />
          </Flex>
        </Box>
        <Box
          minH={{ base: '', md: '260px', xl: '300px' }}
          display="flex"
          alignItems="center"
          margin={{ base: 'auto', md: '0px auto' }}
          padding="0px"
          maxW="717px"
          width={{ base: 'calc(100% - 40px)', lg: '717px' }}
          height={{ base: '100%', md: '590px' }}
        >
          <Container
            padding={{ md: '20px 60px', base: '5px 20px' }}
            maxW="100%"
          >
            {/* <Image src={{base:'sectionContent[1]?.mobileImage.url', lg: 'sectionContent[1]?.image?.url'}} /> */}
            <Image
              alt={sectionContent[1].image?.alt}
              title={sectionContent[1].image?.title}
              textAlign="center"
              loading="eager"
              src={
                isLessThen
                  ? sectionContent[1].mobileImage?.url != null
                    ? sectionContent[1].mobileImage?.url
                    : sectionContent[1].image?.url
                  : sectionContent[1].image?.url
              }
            />
          </Container>
        </Box>
      </Box>
      <style global jsx>
        {`
          .sectiontitle h3 {
            color: #08084a;
            font-size: 60px;
            font-weight: 700;
          }
          @media only screen and (max-width: 834px) {
            .sectiontitle h3 {
              font-size: 43px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default HMM7Step;
